<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Page Not Found</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p>
    Sorry, it looks like there was a problem finding the page you requested:
    {{ desiredUrl }}
  </p>
  <p>
    Please <a [routerLink]="['/support']">contact support</a> if there is a
    problem.
  </p>
</ion-content>
